<template>
    <div id="settings">
        <b-modal id="settings-modal" scrollable modal-class="modal left fade settings-sidebar" size="xl" hide-footer>
            <template #modal-title>
                <section aria-labelledby="setting-title">
                    <h4 id="setting-title" class="pe-1" v-bind:class="[fontSizeSetting, {openDyslexicFont: openDyslexicActive}]">
                        <img class="settings-icon" src="@/assets/images/setting-purple@2x.png" alt="">
                        {{ $t('experience-settings') }}
                    </h4>
                </section>
            </template>
            <div class="setting-content" v-bind:class="[fontSizeSetting, {openDyslexicFont: openDyslexicActive}]">
                <section role="form" :aria-label="$t('toggle-animation')">
                    <div id="animation-section" class="settings-section">
                        <div class="settings-info">
                            <p>{{$t('animation-effect')}}</p>
                        </div>
                        <div class="settings-button">
                            <label for="animationToggle" class="switch">
                                <input
                                    id="animationToggle"
                                    v-model="animationActive"
                                    @change="activateAnimation()"
                                    type="checkbox"
                                    :aria-label="$t('toggle-animation')"
                                >
                                <span class="slider round"></span>
                            </label>
                            <label v-if="animationActive" class="switch-label text-primary mb-0">{{$tc('activated', 2)}}</label>
                            <label v-if="!animationActive" class="switch-label mb-0">{{$tc('deactivated', 2)}}</label>
                        </div>
                    </div>
                </section>
                <section role="form" :aria-label="$t('toggle-font')">
                    <div id="font-section" class="settings-section">
                        <div class="settings-info">
                            <p>{{$t('font-family')}}</p>
                            <h4 class="text-grey mb-sm-5">{{$t('font-helps-dyslexia')}}</h4>
                        </div>
                        <div class="settings-button">
                            <label for="OpenDyslexicToggle" class="switch">
                                <input
                                    id="OpenDyslexicToggle"
                                    v-model="openDyslexicActive"
                                    @change="changeFont()"
                                    type="checkbox"
                                    :aria-label="$t('toggle-font')"
                                >
                                <span class="slider round"></span>
                            </label>
                            <label v-if="openDyslexicActive" class="switch-label text-primary mb-0">{{$tc('activated', 1)}}</label>
                            <label v-if="!openDyslexicActive" class="switch-label mb-0">{{$tc('deactivated', 1)}}</label>
                        </div>
                    </div>
                </section>
                <section role="form" :aria-label="$t('back-to-start')" class="d-md-none d-sm-block mt-4">
                    <div id="back-section" class="row">
                        <div class="back-div col-12 text-center">
                            <button class="back-button btn btn-primary" @click="back()">
                                {{ $t('back-to-start') }}
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { EventBus } from '@/helpers/EventBus.js';
import { Default }  from '@/helpers/Default.js';

export default {
    data () {
        return {
            animationActive:    Default.animationsToggle,
            openDyslexicActive: Default.openDyslexicToggle,
            fontSizeSetting:    Default.size
        };
    },
    i18n: {
        messages: {
            'en': require('@/locales/en.settings.json'),
            'fr': require('@/locales/fr.settings.json')
        }
    },
    mounted () {
        if (this.$session.has('animationsToggle')) {
            this.animationActive = this.$session.get('animationsToggle');
        }

        if (this.$session.has('openDyslexicToggle')) {
            this.openDyslexicActive = this.$session.get('openDyslexicToggle');
        }

        this.fontSizeSetting = this.$session.get('growFont');

        // Update the setting window too when the font size changes
        EventBus.$on('grow-font', this.changeFontSize);
    },
    methods: {
        /**
         * Toggle OpenDyslexic font Event
         */
        changeFont () {
            this.$session.set('openDyslexicToggle', this.openDyslexicActive);

            // Session is not watchable, let's emit an event
            EventBus.$emit('settingsChanged', {
                name:  'openDyslexicToggle',
                value: this.openDyslexicActive
            });
        },

        /**
         * Update the setting page when font size changes
         */
        changeFontSize () {
            this.fontSizeSetting = this.$session.get('growFont');
        },

        /**
         * Toggle Animations Event
         */
        activateAnimation () {
            this.$session.set('animationsToggle', this.animationActive);

            // Session is not watchable, let's emit an event
            EventBus.$emit('settingsChanged', {
                name:  'animationsToggle',
                value: this.animationActive
            });
        },

        /**
         * Reset and go Back to home page
         */
        back () {
            // Hide the setting modal.
            this.$root.$emit('bv::hide::modal', 'settings-modal');

            if (!this.$route.name.includes('home')) {
                // Go to home page.
                this.$router.push({ name: `home:${this.$i18n.locale}` });
            }
        }
    }
};
</script>
